import React from "react";
import { isEmpty } from "lodash";
// components
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import RMDRLink from "@/components/RMDRLink";
import MNPGV2 from "@/components/MainPageLayouts/components/MNPGV2";
import RMDRImage from "@/components/RMDRImage";
// types
import { TMainPageLayoutV2 } from "../type";
// interfaces
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    metaDataLanguageVersion,
    outerTextLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ESizeType from "@/cms/enums/ESizeType";
import { useOutletContext } from "react-router-dom";
import TOutletContext from "@/cms/types/TOutletContext";
import EContentType from "@/cms/enums/EContentType";


const Render = ( props:{ unqKey:string, templates:TClientMainPageItemList[], template:TClientMainPageItemList, readMoreString?:string } ) => {
    
    const { siteSettingPayload } = useOutletContext<TOutletContext>();
    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template.languageVersions);
    const languageVersionTitle = outerTextLanguageVersion(props.template.languageVersions, "find", "title", EContentType.MAIN_PAGE_ITEM);
    const languageVersionDescription = outerTextLanguageVersion(props.template.languageVersions, "find", "description", EContentType.MAIN_PAGE_ITEM);
    const getStartedString = metaDataLanguageVersion("getStartedString", siteSettingPayload.languageVersions);

    return (
        <section className="saas-banner-area pb-70">
            <div className="container-fluid">
                <div className="row align-items-center">

                    <div className="col-lg-6 col-md-12">
                        <div className="saas-banner-content">
                            <RMDRComponentSanitizer 
                                languageVersion={languageVersionTitle}
                                valueExpr="value"
                                variant="h1"
                                extraData={{
                                    "data-aos":"fade-in",
                                    "data-aos-duration":"1000",
                                    "data-aos-delay":"100"
                                }}
                            />
                            
                            <RMDRComponentSanitizer 
                                languageVersion={languageVersionDescription}
                                valueExpr="value"
                                variant="p"
                                extraData={{
                                    "data-aos":"fade-in",
                                    "data-aos-duration":"1000",
                                    "data-aos-delay":"200"
                                }}
                                removeTag
                            />

                            {
                                props.template.hasDestinationNavigation && (
                                    <MNPGV2
                                        templates={props.templates} 
                                        mapLayoutName={props.template.mapLayoutName} 
                                        parentId={props.template.id} 
                                        allowedComponent={['MNPG_024']}
                                    />
                                )
                            }
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div
                            className="saas-banner-image"
                            data-aos="fade-up"
                            data-aos-duration="1000"
                        >
                            <RMDRImage
                                alt={languageVersion?.name}
                                title={languageVersion?.name}
                                resourceType={EResourceType.OUTER_IMAGE} 
                                resources={props.template.resources}
                                disableLazyLoading
                            />
                        </div>
                    </div>

                </div>
            </div>
      </section>
    )

}

const MNPG020 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG020.rendered", props);

    const unqKey = props.template?.id.split("-")[4];
    
    if ( !unqKey || !props.template || isEmpty(props.template) || !props.templates || isEmpty(props.templates) ) return null;

    return <Render unqKey={unqKey} template={props.template} templates={props.templates} />
    
}

const Component = React.memo(MNPG020, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG020.memo", { prevProps, nextProps });
    return true;
});

export default Component;
